import Vue from 'vue';
import Vuex, { GetterTree, MutationTree } from 'vuex';
import LoginInformation from '../types/login_information';
import SessionConf from '../types/session_conf';
import { ViewerContext } from '../types/viewer_context';

Vue.use(Vuex);

interface AppVuexState {
  loginInformation: LoginInformation | null;
  sessionConf: SessionConf;
  loggedStatusResolved: boolean;
}

const appVuexSetters: MutationTree<AppVuexState> = {
  loginInformation(state: AppVuexState, loginInformation: LoginInformation) {
    state.loginInformation = loginInformation;
  },
  setViewAs(
    state: AppVuexState,
    viewAs: { id: string; name: string; type: string }
  ) {
    if (viewAs == null) {
      localStorage.removeItem('viewAsId');
      localStorage.removeItem('viewAsName');
      localStorage.removeItem('viewAsType');
    } else {
      localStorage.setItem('viewAsId', viewAs.id);
      localStorage.setItem('viewAsName', viewAs.name);
      localStorage.setItem('viewAsType', viewAs.type);
    }
    state.sessionConf.viewAs = viewAs;
  },
  setLoggedStatusResolved(state: AppVuexState) {
    state.loggedStatusResolved = true;
  },
};

const appVuexGetters: GetterTree<AppVuexState, any> = {
  isLogged(state) {
    return state.loginInformation != null;
  },
  isLoggedStatusResolved(state) {
    return state.loggedStatusResolved;
  },
  loginInformation(state) {
    return state.loginInformation;
  },
  viewAs(state) {
    return state.sessionConf && state.sessionConf.viewAs;
  },
  isConfirmed(state) {
    return state.loginInformation && state.loginInformation.confirmed;
  },
  viewerContext(state): ViewerContext | null {
    if (
      state.loginInformation &&
      state.loginInformation.admin &&
      state.sessionConf.viewAs
    ) {
      return {
        institutionId: state.sessionConf.viewAs.id,
        institutionName: state.sessionConf.viewAs.name,
        institutionType: state.sessionConf.viewAs.type,
      };
    } else {
      return (
        state.loginInformation && {
          institutionId: state.loginInformation.institution.id,
          institutionName: state.loginInformation.institution.name,
          institutionType: state.loginInformation.institution.type,
        }
      );
    }
  },
};

const viewAsId = localStorage.getItem('viewAsId');
const viewAsName = localStorage.getItem('viewAsName');
const viewAsType = localStorage.getItem('viewAsType');

export default new Vuex.Store<AppVuexState>({
  state: {
    loginInformation: null,
    loggedStatusResolved: false,
    sessionConf: {
      viewAs:
        viewAsId && viewAsName && viewAsType
          ? { id: viewAsId, name: viewAsName, type: viewAsType }
          : null,
    },
  },
  getters: appVuexGetters,
  mutations: appVuexSetters,
  modules: {},
});
